import React from 'react'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { AdminSaleOffer } from 'src/core/models'
import { currencyListSelector } from 'src/features'
import styles from './AdminSaleOfferMovileViewColumn.module.scss'
import { getFirstSubstring, getFormatedPrice, getProjectUnit } from 'src/core/helpers'
import { CustomTitle, CustomText, CustomTag, AdminSaleOfferActionsColumn } from 'src/components'

const AdminSaleOfferMovileViewColumn: React.FC<{ offer: AdminSaleOffer }> = ({ offer }) => {
  const { t } = useTranslation()
  // Persons
  const clientEmailAux = offer.client_email
  const clientEmail = clientEmailAux.length > 24 ? `${getFirstSubstring(clientEmailAux, 21)}...` : clientEmailAux

  const adminEmailAux = offer.sales_agent_email
  const adminEmail = adminEmailAux.length > 24 ? `${getFirstSubstring(adminEmailAux, 21)}...` : adminEmailAux

  // Project
  const vintageLabel = offer.vintage_year ? `(${offer.vintage_year})` : ''
  const projectlabel = `${offer.project_name} ${vintageLabel} - (${offer.project})`

  // Amount
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList.find(c => c.id === offer.currency)?.code
  const amountLabel = `${offer.amount} ${getProjectUnit(offer.project_kind)}`
  const priceLabel = getFormatedPrice(offer.price_per_unit, currencyCode)
  const finalPriceLabel = `${priceLabel} x ${amountLabel}`

  // Status
  const tagType = {
    expired: 'default',
    accepted: 'success',
    rejected: 'error',
    open: 'processing'
  }[offer.status] || 'default'

  return <div className={styles.content}>
    <CustomTitle
      label={clientEmail}
      type={null}
    />
    <CustomText
      label={adminEmail}
      type='secondary'
      className={styles.saleAgent}
    />
    <CustomText label={projectlabel} type='secondary' />
    <CustomText label={finalPriceLabel} type='secondary' />
    {(offer.show_discount && offer.discount) && <>
      <CustomText label={`${offer.discount}%`} type='secondary' mark/>
    </>}

    <div className={styles.typeContent}>
      <CustomTag
        text={t(`SalesOffer.${offer.type}`)}
        type='default'
        showIcon
      />
      <CustomTag
        text={t(`SalesOffer.${offer.status}`)}
        type={tagType}
        showIcon
      />
    </div>

    <div className='centered'>
      <AdminSaleOfferActionsColumn offer={offer} />
    </div>
  </div>
}

export default AdminSaleOfferMovileViewColumn
